import type { JSX } from 'react'

// TODO: replace with new icons from Figma
export const GoogleSolidIcon = (): JSX.Element => (
  <use href='#googleSolidIcon' height='100%' width='100%' />
)
